<template>
  <v-container fluid>
    <v-card flat color="background" class="mb-10">
      <v-card-title primary-title>Holiday Hours</v-card-title>
      <v-card-subtitle>Tweak hours of operations for certain days and occasions</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              class="background class-on-data-table"
              :headers="headers"
              :items="holidayHours"
            >
              <template v-slot:item.is_active="{ item }">
                <v-switch
                  inset
                  @change="toggleHolidayStatus(item)"
                  :label="item.is_active? 'Enabled': 'Disabled'"
                  v-model="item.is_active"
                ></v-switch>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="editHolidayHours(item)" fab small v-on="on" color="primary">
                      <v-icon small>settings</v-icon>
                    </v-btn>
                  </template>
                  <span>Configure Hours</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="deleteHoliday(item)"
                      class="ml-2"
                      fab
                      small
                      v-on="on"
                      color="primary"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="newHolidayHours.dialog = true"
          fab
          fixed
          dark
          bottom
          right
          color="primary"
          v-on="on"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Add Holiday Hours</span>
    </v-tooltip>
    <create-holiday-hours-modal
      v-if="newHolidayHours.dialog"
      :editHolidayHours="newHolidayHours.currentSelected"
      @close-modal="closeModal"
      :status="newHolidayHours.dialog"
      @holiday-hours-created="getLocationHolidayHours();closeModal()"
      @holiday-hours-updated="getLocationHolidayHours();closeModal()"
    />
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  mounted() {
    this.$root.$on('item-deleted', (s) => {
      this.getLocationHolidayHours()
      this.swal({ title: 'Success', text: 'Holiday Hours deleted successfully.', timer: 3000 })
    })
    this.getLocationHolidayHours()
  },
  data() {
    return {
      newHolidayHours: {
        dialog: false,
        currentSelected: {}
      },
      holidayHours: [],
      headers: [{
        text: 'Holiday Name',
        value: 'display_name',
        width: '17.5%'
      },
      {
        text: 'Message',
        value: 'message',
        width: '27.5%'
      },
      {
        text: 'Start Date',
        value: 'start_date',
        width: '15%'

      },
      {
        text: 'End Date',
        value: 'end_date',
        width: '15%'
      },
      {
        text: 'Active',
        value: 'is_active',
        width: '13%'
      }, {
        text: 'Actions',
        value: 'actions',
        width: '12%'
      }]
    }
  },
  components: {
    CreateHolidayHoursModal: () => import('./createHolidayHoursModal')
  },
  methods: {
    async getLocationHolidayHours() {
      let response
      try {
        response = await LocationAPI.getLocationHolidayHours(this.$route.params.id)
      } catch (error) {
        this.holidayHours = []
        return console.log(error)
      }
      this.holidayHours = response.data.payload
    },
    editHolidayHours(holidayHours) {
      this.newHolidayHours.currentSelected = holidayHours
      this.newHolidayHours.dialog = true
    },
    closeModal() {
      this.newHolidayHours.dialog = false
      this.newHolidayHours.currentSelected = {}
    },
    deleteHoliday(holiday) {
      let data = { location_id: this.$route.params.id }
      this.openDeleteModal({ title: `Delete ${holiday.display_name} ?`, callback: () => LocationAPI.deleteHoliday(holiday.id, data) })
    },
    async toggleHolidayStatus(holiday) {
      let data = {
        location_id: this.$route.params.id,
        enable: holiday.is_active
      }
      try {
        await LocationAPI.toggleHolidayHourStatus(holiday.id, data)
      } catch (error) {
        holiday.is_active = !holiday.is_active
        return console.log(error)
      }
      if (!holiday.is_active) {
        this.snackbar({ text: 'Holiday Hours Disabled', color: 'warning darken-1' })
      } else {
        this.snackbar({ text: 'Holiday Hours Enabled', color: 'success', icon: 'check' })
      }
    }
  }
}
</script>

<style lang="scss">
.class-on-data-table table {
  table-layout: fixed;
}
</style>
